import { useAppActions } from "../../app/AppProvider.tsx";
import { summarizeAccount } from "../Accounts.helpers.ts";

type AccountChipProps = {
  sessionId: string | undefined;
  variant?: "inline" | "overlay";
};

/** Small badge that identifies which account owns a chat row or avatar. */
export function AccountChip({ sessionId, variant = "inline" }: AccountChipProps) {
  const { state } = useAppActions();
  if (!state.accounts || state.accounts.length < 2) return null;

  let account = sessionId ? state.accounts.find((candidate) => candidate.sessionId === sessionId) : undefined;
  if (!account) {
    account = state.accounts.find((candidate) => candidate.isDefault) || state.accounts[0];
  }
  if (!account) return null;

  const summary = summarizeAccount(account);
  return (
    <span
      className={`account-chip ${variant === "overlay" ? "overlay" : ""}`}
      title={`${summary.label} \u00b7 ${summary.provider}`}
      style={{ background: summary.badgeColor }}
    >
      {summary.badge}
    </span>
  );
}
